import { Injectable } from "@angular/core";
import { BaseClient } from "../base-client/base-client";
import { IBaseClient } from "../base-client/interface";

@Injectable({
  providedIn: 'root'
})
export class ZohoClient extends BaseClient implements IBaseClient {
  constructor() {
    super();
  }

  override needsAgentList = true;
  override requireTermsModal = true;
  override allowedToUseCapture = true;
}
